import Vue from "vue";
import VueI18n from "vue-i18n";
import AppLocales from "../locales";

Vue.use(VueI18n);
const curLocale = localStorage.getItem('locale');

export default new VueI18n({
    locale: curLocale ? curLocale : (window.lang && window.lang.name) || "tr",
    fallbackLocale: curLocale ? curLocale : (window.lang && window.lang.name) || "tr",
    messages: AppLocales
});